import { createTheme } from '@mui/material/styles';

declare module '@mui/material/styles' {
  interface BreakpointOverrides {
    desktop: true;
  }
}

declare module '@mui/material/Button' {
  interface ButtonPropsVariantOverrides {
    grayPainted: true;
  }
}

export const theme = createTheme({
  typography: {
    fontFamily: 'Pretendard',
  },
  breakpoints: {
    values: {
      desktop: 1090,
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,
    },
  },
  palette: {
    primary: {
      main: '#5EBEBB',
    },
    secondary: {
      main: '#969696',
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          fontFamily: ['Pretendard', 'ui-sans-serif', 'system-ui'].join(','),
        },
      },
    },
    MuiButtonBase: {
      defaultProps: {
        disableRipple: true,
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          padding: 0,
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          color: '#fff',
          padding: '10px',
          border: 'none',
          borderRadius: '10px',
          boxShadow: 'none',
          boxSizing: 'border-box',
          fontSize: '16px',
          fontFamily: 'Pretendard',
          fontWeight: '700',
          lineHeight: '24px',
          wordBreak: 'keep-all',
          whiteSpace: 'nowrap',
          textTransform: 'initial',
          //@ts-ignore
          display: 'flex',
          alignItems: 'center',
          background: '#5EBEBB',
          '&:hover': {
            boxShadow: 'none',
          },
        },
      },
      variants: [
        {
          props: { variant: 'contained' },
          style: {
            background: '#5EBEBB',
            '&:hover': {
              background: '#5ebebb',
            },
            '&:disabled': {
              opacity: 0.5,
              color: '#969696',
              background: '#F3F3F3',
            },
          },
        },
        {
          props: { variant: 'outlined' },
          style: {
            color: '#363636',
            background: '#FFF',
            border: '1px solid #E0E0E0',
            '&:hover': {
              color: '#969696',
              background: '#FFF',
              border: '1px solid #E0E0E0',
            },
            '&:disabled': {
              opacity: 0.5,
            },
            '&:active': {
              color: '#969696',
              background: '#FFF',
              border: '1px solid #E0E0E0',
            },
          },
        },
        {
          //@ts-ignore
          props: { variant: 'grayPainted' },
          style: {
            color: '#416BFF',
            background: '#F6F6F6',
            border: 'none',
            '&:disabled': {
              opacity: 0.5,
            },
          },
        },
      ],
    },
  },
});
